exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-400 .el-dialog{background-color:#fff;border:1px solid #2196f3;box-shadow:3px 3px 5px rgba(0,0,0,.6);width:400px}.dialog-400 .el-dialog__body{padding:5px 20px 20px}.dialog-400 .el-dialog__header{background-color:#eee;padding:8px 0;text-align:center}.dialog-400 .el-dialog__title{font-size:14px;color:#666}.dialog-400 .el-dialog__headerbtn{display:none}.dialog-400 .el-dialog__footer{padding:20px 0 30px;text-align:center}", ""]);

// exports
